import { Spin } from 'antd';
import * as React from 'react';

/** Lazy-load design gallery category pages so prod bundle stays smaller when flag is off. */
export const lazyGalleryPage = (
  loader: () => Promise<{ default: React.ComponentType<object> }>
): React.FC => {
  const LazyPage = React.lazy(loader);
  const Wrapped: React.FC = () => (
    <React.Suspense
      fallback={
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '40vh',
            width: '100%',
          }}
        >
          <Spin size="large" />
        </div>
      }
    >
      <LazyPage />
    </React.Suspense>
  );
  return Wrapped;
};

export const DesignSystemHubPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/index')
);
export const DesignSystemButtonsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/buttons')
);
export const DesignSystemFormsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/forms')
);
export const DesignSystemDataDisplayPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/data-display')
);
export const DesignSystemFeedbackPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/feedback')
);
export const DesignSystemOverlaysPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/overlays')
);
export const DesignSystemLayoutPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/layout')
);
export const DesignSystemPatternsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/patterns')
);
export const DesignSystemTablesPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/tables')
);
export const DesignSystemAiPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/ai')
);
export const DesignSystemProvidersPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/providers')
);
export const DesignSystemListsCardsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/lists-cards')
);
export const DesignSystemIntegrationsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/integrations')
);
export const DesignSystemDataRetrievalPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/data-retrieval')
);
export const DesignSystemIconsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/icons')
);
export const DesignSystemUtilitiesPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/utilities')
);
export const DesignSystemFeatureDotsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/feature-dots')
);
export const DesignSystemNavigationPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/navigation')
);
export const DesignSystemWorkflowsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/workflows')
);
export const DesignSystemSubmissionsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/submissions')
);
export const DesignSystemDashboardPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/dashboard')
);
export const DesignSystemVatReturnsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/vat-returns')
);
export const DesignSystemMappingPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/mapping')
);
export const DesignSystemPermissionsPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/permissions')
);
export const DesignSystemAuthPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/auth')
);
export const DesignSystemBillingPage = lazyGalleryPage(() =>
  import('pages/dev/design-system/billing')
);
export const DesignSystemAntdThemePage = lazyGalleryPage(() =>
  import('pages/dev/design-system/antd-theme')
);
